// This file was automatically generated from app.shared.dialog.survey.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.survey');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyDialog"><p class="el8DialogTopButtons el8SurveyDialogButtons"><button class="remind-dropdown-trigger ebs-btn ebs-btn-default">Dismiss<span class="el8DownArrowIcon"></span></button></p><form class="el8SurveyForm"></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.notificationContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyDialog"><p class="el8DialogTopButtons el8SurveyDialogButtons"><button class="remind-dropdown-trigger ebs-btn ebs-btn-default">Dismiss<span class="el8DownArrowIcon"></span></button></p><div class="el8PromptDialogContainer"><p class="el8PromptDialogText el8Preserve">', soy.$$escapeHtml(opt_data.text), '</p>', (opt_data.link && opt_data.linkText) ? '<p class="el8PromptDialogText el8Preserve mt15"><a target="_blank" rel="noopener" href="' + soy.$$escapeHtml(opt_data.link) + '">' + soy.$$escapeHtml(opt_data.linkText) + '</a></p>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.nps = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyQuestionWrapNPS"><h3 class="el8SurveyQuestion">', soy.$$escapeHtml(opt_data.question), '</h3><div class="clearfix ebs-clearfix"><div class="el8SurveyScaleCaption0to10">', soy.$$escapeHtml(opt_data.scaleLowCaption), '</div><div class="el8SurveyScaleCaption0to10" style="text-align: right;">', soy.$$escapeHtml(opt_data.scaleHighCaption), '</div></div><div class="clearfix ebs-clearfix">');
  for (var i8815 = 0; i8815 < 11; i8815++) {
    output.append('<label class="el8SurveyScaleDigit" for=\'', soy.$$escapeHtml(opt_data.questionId), '_', soy.$$escapeHtml(i8815), '\'>', soy.$$escapeHtml(i8815), '</label>');
  }
  output.append('</div><div class="clearfix ebs-clearfix">');
  for (var i8824 = 0; i8824 < 11; i8824++) {
    output.append('<div class="el8SurveyScaleInputDiv"><input type="radio" name="', soy.$$escapeHtml(opt_data.questionId), '" id="', soy.$$escapeHtml(opt_data.questionId), '_', soy.$$escapeHtml(i8824), '" value="', soy.$$escapeHtml(i8824), '"></div>');
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.zeroToTenScale = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyQuestionWrap"><h3 class="el8SurveyQuestion">', soy.$$escapeHtml(opt_data.question), '</h3><div class="clearfix ebs-clearfix"><div class="el8SurveyScaleCaption">', soy.$$escapeHtml(opt_data.scaleLowCaption), '</div><div class="el8SurveyScaleCaption" style="text-align: right;">', soy.$$escapeHtml(opt_data.scaleHighCaption), '</div></div><div class="clearfix ebs-clearfix">');
  for (var i8843 = 1; i8843 < 11; i8843++) {
    output.append('<label class="el8SurveyScaleDigit" for=\'', soy.$$escapeHtml(opt_data.questionId), '_', soy.$$escapeHtml(i8843), '\'>', soy.$$escapeHtml(i8843), '</label>');
  }
  output.append('</div><div class="clearfix ebs-clearfix">');
  for (var i8852 = 1; i8852 < 11; i8852++) {
    output.append('<div class="el8SurveyScaleInputDiv"><input type="radio" name="', soy.$$escapeHtml(opt_data.questionId), '" id="', soy.$$escapeHtml(opt_data.questionId), '_', soy.$$escapeHtml(i8852), '" value="', soy.$$escapeHtml(i8852), '"></div>');
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.freeText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="survey-freetext el8SurveyQuestionWrap ', (opt_data.hidden) ? 'el8Hidden' : '', '"><h3 class="el8SurveyQuestion">', soy.$$escapeHtml(opt_data.question), '</h3><div class="el8TextareaWrap el8SurveyTextareaWrap"><textarea type="text" name="', soy.$$escapeHtml(opt_data.questionId), '" class="fieldInputText w100 ebs-form-control"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.checkBox = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyCheckBoxWrap">', (opt_data.listIntroText) ? '<h3 class="el8SurveyQuestion el8SurveyListIntroText">' + soy.$$escapeHtml(opt_data.listIntroText) + '</h3>' : '', '<ul class="el8ListSpacing ebs-list-unstyled"><li class="el8NoBullet"><input type="checkbox" name="', soy.$$escapeHtml(opt_data.questionId), '" id="', soy.$$escapeHtml(opt_data.questionId), '" value="1"><label class="el8NormalText el8LargeFontSize el8SurveyAnswer ml10" for="', soy.$$escapeHtml(opt_data.questionId), '">', soy.$$escapeHtml(opt_data.question), '</label></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.yesNoRadio = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyQuestionWrap"><h3 class="el8SurveyQuestion">', soy.$$escapeHtml(opt_data.question), '</h3><ul class="el8ListSpacing ebs-list-unstyled">');
  el8.template.app.shared.dialog.survey.yesNoSection(opt_data, output);
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.yesNoMaybeRadio = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyQuestionWrap"><h3 class="el8SurveyQuestion">', soy.$$escapeHtml(opt_data.question), '</h3><ul class="el8ListSpacing ebs-list-unstyled">');
  el8.template.app.shared.dialog.survey.yesNoSection(opt_data, output);
  output.append('<li class="el8NoBullet"><input type="radio" name="', soy.$$escapeHtml(opt_data.questionId), '" id="', soy.$$escapeHtml(opt_data.questionId), '_maybe" value="maybe"><label class="el8NormalText el8LargeFontSize el8SurveyAnswer ml10" for="', soy.$$escapeHtml(opt_data.questionId), '_maybe">', soy.$$escapeHtml(opt_data.maybeCaption), '</label></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.survey.yesNoSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8NoBullet"><input type="radio" name="', soy.$$escapeHtml(opt_data.questionId), '" id="', soy.$$escapeHtml(opt_data.questionId), '_yes" value="yes" ><label class="el8NormalText el8LargeFontSize el8SurveyAnswer ml10" for="', soy.$$escapeHtml(opt_data.questionId), '_yes">', soy.$$escapeHtml(opt_data.yesCaption), '</label></li><li class="el8NoBullet"><input type="radio" name="', soy.$$escapeHtml(opt_data.questionId), '" id="', soy.$$escapeHtml(opt_data.questionId), '_no" value="no"><label class="el8NormalText el8LargeFontSize el8SurveyAnswer ml10" for="', soy.$$escapeHtml(opt_data.questionId), '_no">', soy.$$escapeHtml(opt_data.noCaption), '</label></li>');
  if (!opt_sb) return output.toString();
};
